import { __assign, __generator } from "tslib";
import { call } from '@redux-saga/core/effects';
import ddt from '@wix/da-ddt';
import { convertToServerXhrPayload } from '../../DaEditorWrapper/utils';
import { request } from '../../xhr';
export function makePostsPayload(commentData) {
    var editorContent = commentData.editorContent, rawContentState = commentData.rawContentState, featuresData = commentData.featuresData, typeId = commentData.typeId, itemId = commentData.itemId, editComment = commentData.editComment, replyComment = commentData.replyComment, messageId = commentData.messageId, folderId = commentData.folderId, shouldDeleteMessage = commentData.shouldDeleteMessage;
    return __assign({ typeid: typeId, itemid: itemId, commentid: editComment ? editComment.commentId : undefined, parentid: replyComment ? replyComment.commentId : undefined, mcid: messageId, folderid: folderId, should_delete: shouldDeleteMessage }, convertToServerXhrPayload(rawContentState, editorContent, featuresData));
}
export function sendPublishRequest(commentData) {
    var postData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                postData = makePostsPayload(commentData);
                ddt.log('comments', 'posting a comment', postData);
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: "/comments/post",
                        data: postData,
                    }, fakePostResponse)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
function fakePostResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (typeof window !== 'undefined' && window.doError) {
            return {
                error: 'invalid_request',
                errorDescription: 'Not logged in.',
                status: 'error',
            };
        }
        // eslint-disable-next-line
        var comments = require('@wix/da-sample-data').comments;
        var comment = comments[0];
        if (options.url === '/comments/post') {
            comment.posted = Date.now();
            comment.likes = 0;
            comment.isAuthor = true;
            var body = {
                excerpt: '',
                html: {
                    type: 'draft',
                    markup: options.data.editorRaw,
                    features: '',
                },
            };
            comment.textContent = body;
        }
        if (options.data.parentid) {
            comment.parentId = options.data.parentid;
        }
        if (options.data.commentid) {
            comment.commentId = options.data.commentid;
        }
        return comment;
    }
}
//# sourceMappingURL=utils.js.map